import React from "react";
import {
  seller1,
  seller2,
  seller3,
  seller4,
  seller5,
  seller6,
  seller7,
  seller8,
} from "../Constant/Index";
import { Link } from "react-router-dom";

function Trendingsproduct() {
  const sellerstuff = [
    {
      img: seller1,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller2,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller3,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller4,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller5,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller6,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller7,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
    {
      img: seller8,
      name: "product name",
      price: "$20",
      para: "We believe in natural beauty",
    },
  ];
  return (
    <>
      {/* Best Seller */}
      <section className="best-seller-sec">
        <div className="container">
          <div className="best-seller-heading">
            <span className="font-chalottre natural-heading">natural</span>
            <h2 className="primary-color">Trending Products</h2>
          </div>
          <div className="row">
            {sellerstuff?.map((data, sellerindex) => {
              return (
                <>
                  <div className="col-md-3" key={sellerindex}>
                    <div className="seller-all">
                      <div className="seller-img">
                        <Link to="/shop-detail">
                          {" "}
                          <img src={data?.img} className="img-fluid" />
                        </Link>
                        <div className="add-to-cart">
                          <span className="primary-color">
                            {" "}
                            <i
                              class="fa fa-shopping-basket"
                              aria-hidden="true"
                            ></i>
                            <Link to="/cart">
                              {" "}
                              <button className="priamry-color">
                                add to cart
                              </button>
                            </Link>
                          </span>
                          <span className="primary-color primary-heart">
                            <i class="fa fa-heart" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                      <div className="seller-head-para">
                        <h3 className="primary-color">
                          {data?.name} <span> | {data?.price}</span>
                        </h3>
                        <p>{data?.para}</p>
                      </div>
                      <div className="seller-stars">
                        <ul>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star primary-color"
                              aria-hidden="true"
                            ></i>
                          </li>
                          <li>
                            <i
                              class="fa fa-star extra-color-6"
                              aria-hidden="true"
                            ></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
      {/* ================= */}
    </>
  );
}

export default Trendingsproduct;
